import { notificationActions } from "../../actionTypes";

const initialState = {
	count: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case notificationActions.FETCH_NOTIFICATIONS_COUNT: {
			return { ...initialState, fetching: true };
		}

		case notificationActions.FETCH_NOTIFICATIONS_COUNT_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				count: action.payload,
			};
		}

		case notificationActions.FETCH_NOTIFICATIONS_COUNT_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
